import {Component, Input, forwardRef, OnInit} from '@angular/core';
import {NG_VALUE_ACCESSOR, NG_VALIDATORS} from '@angular/forms';
import {AbstractFieldClass} from '../abstract-field.class';
import {ApiClientService} from '../../../services/api-client.service';

@Component({
    selector: 'service-request-type-field',
    templateUrl: 'service-request-type-field.component.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ServiceRequestTypeFieldComponent), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => ServiceRequestTypeFieldComponent), multi: true }
    ]
})
export class ServiceRequestTypeFieldComponent extends AbstractFieldClass implements OnInit {
    @Input() title = '';
    @Input() optionTitleKey = 'name';
    @Input() requestTypes: Array<any>;

    constructor(public api: ApiClientService) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();
        this.value = this.value ? this.value : '0';
        this.type = this.type || '';
        this.getRequestTypes();
    }

    get type() {
        return this._type;
    }

    set type(val) {
        this._type = val || '';
        this.propagateChange(val);
    }

    public validator(value): boolean {
        return true;
    }

    getRequestTypes() {
        this.requestTypes = [];
        const url = `/v1/service_request_type.json`;
        this.api.get('domainServiceRequest', url).subscribe(
            res => {
                const types = JSON.parse(res._body).entities || [];
                this.requestTypes = types.map(type => ({id: type.id, name: type.name}));
            },
            error => this.api.errorHandler(error, 'Failed get types')
        );
    }

    getValueById(id: any): any {
        if (id === null) return false;

        if (+id === 0) {
            return this._type;
        } else {
            let selectedItem;

            if (this.requestTypes && this.requestTypes.length) {
                selectedItem = this.requestTypes.find((elem) => +elem.id === +id);
            }

            return (selectedItem) ? selectedItem[this.optionTitleKey] : false;
        }
    }

}




// WEBPACK FOOTER //
// /app/src/app/components/fields/service-request-type-field/service-request-type-field.component.ts